module.exports = __webpack_public_path__ + "img/card4.31b59bdd.png";